import formatDate from './formatDate'
import getExcerpt from './getExcerpt'
import highlightYears from './highlightYears'
import stripHTMLTags from './stripHTMLTags'

export { formatDate, getExcerpt, highlightYears, stripHTMLTags }
